import { BASE_THEME_ID } from 'owa-theme/lib/utils/themeConstants';

const darkModeSupport = {
    [BASE_THEME_ID]: true,
};

export function themeSupportsDarkMode(themeId: string): boolean {
    return !!darkModeSupport[themeId];
}
